import { roles, routes } from "../constants/roles";

export const mainRoutes = [
  {
    label: 'Home',
    to: routes.home,
    roles: [
      roles.admin,
      roles.purchaseExecutiveGCview,
      roles.managingDirector,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,
      roles.Chairman,
      roles.GmProjects,
      roles.Auditor,
      roles.ceo,
      roles.factorymanager,
      roles.generalUser,
      roles.gmc,
      roles.marketingExecutive,
      roles.managerCommerical,
      roles.commercialHod,
      roles.commercialExecutive,
      roles.commercialAssociative,
      roles.asstManagerPurchase,
      roles.managerPurchaseGC,
      roles.GeneralManagerPurchase,
      roles.managerGCStores,
      roles.managerStoresPackingAndGC,
      roles.purchaseExecutiveGC,
      roles.gcStoresExecutive,
      roles.srManager,
      roles.qcManager,
      roles.qcHead,
      roles.accountsExecutive,
      roles.accountsManager,
      roles.vendor,
      roles.marketingRepresentative,
      roles.managerPackagingDevelopment,
      roles.purchaseManager,
      roles.managerPurchaseGCQuotes,
      roles.managerPurchasePackaging,
      roles.BusinessDevelopmentManager,
      roles.BDDomestic,
      roles.packingExecutive,
      roles.purchaseExecutiveME,
      roles.rdManager,
      roles.RDManagerBD,
      roles.rdAssociate,
      roles.AnalystQA,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentExecutive
    ]
  },
  {
    label: 'Leads',
    to: routes.leads,
    roles: [
      roles.admin,
      roles.marketingExecutive,
      roles.RDManagerBD,
      roles.managingDirector,
      roles.managerfinance,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman,
      roles.GmProjects,
      roles.Auditor,
      roles.ceo,
      roles.factorymanager,
      roles.BusinessDevelopmentManager,
      roles.BDDomestic,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentExecutive
    ],
  },
  {
    label: 'Accounts',
    to: routes.accounts,
    roles: [
      roles.admin,
      roles.marketingExecutive,
      roles.RDManagerBD,
      roles.managingDirector,
      roles.managerfinance,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman,
      roles.GmProjects,
      roles.Auditor,
      roles.ceo,
      roles.factorymanager,
      roles.BusinessDevelopmentManager,
      roles.BDDomestic,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentExecutive
    ]
  },
  {
    label: 'Contacts',
    to: routes.contacts,
    roles: [
      roles.admin,
      roles.marketingExecutive,
      roles.RDManagerBD,
      roles.managingDirector,
      roles.managerfinance,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman,
      roles.GmProjects,
      roles.Auditor,
      roles.ceo,
      roles.factorymanager,
      roles.BusinessDevelopmentManager,
      roles.BDDomestic,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentExecutive
    ]
  },
  {
    label: 'Sample Request',
    to: routes.sampleRequest,
    roles: [roles.qcManager,
    roles.qcHead,
    roles.admin,
    roles.marketingExecutive,
    roles.rdManager,
    roles.rdAssociate,
    roles.RDManagerBD,
    roles.managerfinance,
    roles.managingDirector,
    roles.Auditor,
    roles.executiveLeadership,
    roles.viewOnly,
    roles.readOnly,
    roles.Chairman,
    roles.GmProjects,
    roles.ceo,
    roles.factorymanager,
    roles.BusinessDevelopmentManager,
    roles.BDDomestic,
    roles.BDManager,
    roles.BusinessDevelopmentHod,
    roles.productionAssistant,
    roles.ProductionManager,
    roles.BusinessDevelopmentExecutive
    ]
  },
  {
    label: 'Master Samples',
    to: routes.masterSample,
    roles:[ roles.admin, roles.managingDirector]
  },
  //alternative Sample
  {
    label: 'Alternative Samples',
    to: routes.alternativeSample,
    roles: [
      roles.admin,
      roles.managingDirector,
      roles.GmProjects,
      roles.managerfinance,
      roles.rdManager,
      roles.RDManagerBD,
      roles.rdAssociate,
      roles.qcManager,
      roles.qcHead,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman,
      roles.ceo,
      roles.factorymanager,
      roles.productionAssistant,
      roles.ProductionManager,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentExecutive,
      roles.BDDomestic,
      roles.BusinessDevelopmentManager
    ]
  },
  //customer sample
  {
    label: 'Customer Samples',
    to: routes.customerSample,
    roles: [
      roles.admin,
      roles.managingDirector,
      roles.rdManager,
      roles.RDManagerBD,
      roles.managerfinance,
      roles.qcManager,
      roles.qcHead,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman,
      roles.GmProjects,
      roles.Auditor,
      roles.ceo,
      roles.factorymanager,
      roles.BDDomestic,
      roles.BusinessDevelopmentManager,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.productionAssistant,
      roles.ProductionManager,
      roles.BusinessDevelopmentExecutive
    ]
  },
  {
    label: 'Quotation',
    to: routes.quotation,
    roles: [
      roles.admin,
      roles.gmc,
      roles.BusinessDevelopmentExecutive,
      roles.managerCommerical,
      roles.commercialExecutive,
      roles.commercialHod,
      roles.purchaseExecutiveGC,
      roles.managingDirector,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman,
      roles.managerfinance,
      roles.GmProjects,
      roles.Auditor,
      roles.ceo,
      roles.factorymanager,
      roles.asstManagerPurchase,
      roles.marketingExecutive,
      roles.RDManagerBD,
      roles.managerPurchaseGC,
      roles.GeneralManagerPurchase,
      roles.packingExecutive,
      roles.BDDomestic,
      roles.BusinessDevelopmentManager,
      roles.BusinessDevelopmentExecutive,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.managerPurchasePackaging
    ]
  },
  {
    label: 'Users',
    to: routes.users,
    roles: [
      roles.admin,
      roles.managingDirector,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,
      roles.Chairman,
      roles.GmProjects,
      roles.Auditor,
      roles.ceo
    ]
  },
  {
    label: 'Purchase Orders',
    to: routes.purchaseOrders,
    roles: [ roles.admin,roles.managingDirector, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman,roles.GmProjects, roles.Auditor,roles.ceo,roles.factorymanager, roles.managerPurchaseGC,roles.GeneralManagerPurchase,
    roles.managerStoresPackingAndGC, roles.purchaseExecutiveGC,
    roles.asstManagerPurchase, roles.gcStoresExecutive,roles.purchaseExecutiveGCview,
    roles.accountsManager, roles.managerGCStores, roles.qcManager, roles.qcHead]
  },
  {
    label: 'Debit Note GC',
    to: routes.debitNoteGC,
    roles: [ roles.admin,roles.managingDirector, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman,roles.GmProjects, roles.Auditor,roles.ceo,roles.factorymanager, roles.managerPurchaseGC,roles.GeneralManagerPurchase,
    roles.accountsExecutive, roles.accountsManager, roles.purchaseExecutiveGC]
  },
  {
    label: 'MRIN',
    to: routes.mrin,
    roles: [ roles.admin,roles.gcStoresExecutive,roles.purchaseExecutiveGCview, roles.managerStoresPackingAndGC,
    roles.srManager, roles.qcManager, roles.qcHead, roles.managingDirector, roles.executiveLeadership,
    roles.viewOnly,
    roles.readOnly,
    roles.managerfinance,roles.Chairman,roles.GmProjects, roles.Auditor,roles.ceo,roles.factorymanager, roles.accountsExecutive,
    roles.accountsManager, roles.managerPurchaseGC,roles.GeneralManagerPurchase, roles.managerGCStores, roles.AnalystQA,, roles.purchaseExecutiveGC,roles.rdManager,
    roles.rdAssociate,
    roles.RDManagerBD, roles.qcManager, roles.qcHead]
  },
  {
    label: 'GC',
    to: routes.gc,
    roles: [ roles.admin,roles.managingDirector, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman,roles.GmProjects, roles.Auditor,roles.ceo,roles.factorymanager, roles.gcStoresExecutive,
    roles.managerStoresPackingAndGC, roles.managerPurchaseGC,roles.GeneralManagerPurchase,roles.GeneralManagerPurchase, roles.managerGCStores,, roles.purchaseExecutiveGC, roles.rdManager,
    roles.rdAssociate,
    roles.RDManagerBD],
  },
  {
    label: 'Supplier',
    to: routes.supplier,
    roles: [ roles.admin,roles.managingDirector, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman,roles.GmProjects, roles.Auditor,roles.ceo,roles.factorymanager, roles.purchaseManager, roles.managerPurchaseGC,roles.GeneralManagerPurchase, roles.accountsManager, roles.purchaseExecutiveME, roles.purchaseExecutiveGC]
  },
  {
    label: 'Settings',
    to: routes.settings,
    roles: [roles.admin]
  },
  {
    label: 'Packing Type',
    to: routes.packingType,
    roles: [ roles.admin,roles.managingDirector, roles.packingExecutive,roles.managerPurchasePackaging,roles.Auditor,]
  },
  {
    label: 'Blend Sheet',
    to: routes.blendSheet,
    roles: [
      roles.admin,
      roles.managingDirector,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,
      roles.Chairman,
      roles.GmProjects,
      roles.Auditor,
      roles.ceo,
      roles.factorymanager,
      roles.generalUser,
      roles.gmc,
      roles.marketingExecutive,
      roles.managerCommerical,
      roles.commercialExecutive,
      roles.commercialHod,
      roles.asstManagerPurchase,
      roles.managerPurchaseGC,
      roles.GeneralManagerPurchase,
      roles.managerGCStores,
      roles.managerStoresPackingAndGC,
      roles.purchaseExecutiveGC,
      roles.gcStoresExecutive,
      roles.srManager,
      roles.qcManager,
      roles.qcHead,
      roles.accountsExecutive,
      roles.accountsManager,
      roles.vendor, roles.marketingRepresentative,
      roles.managerPackagingDevelopment,
      roles.purchaseManager,
      roles.managerPurchaseGCQuotes,
      roles.managerPurchasePackaging,
      roles.BusinessDevelopmentManager,
      roles.BDDomestic,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.packingExecutive,
      roles.purchaseExecutiveME,
      roles.rdManager,
      roles.rdAssociate,
      roles.RDManagerBD,
      roles.AnalystQA,
      roles.productionAssistant,
      roles.ProductionManager,
      roles.BusinessDevelopmentExecutive
    ]
  },
  {
    label: 'Certification',
    to: routes.certification,
    roles: [ roles.admin,roles.managingDirector,roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman,roles.GmProjects, roles.Auditor,roles.ceo,roles.factorymanager,roles.qcManager,roles.qcHead,roles.AnalystQA,roles.BDDomestic,roles.BusinessDevelopmentManager,roles.BDManager, roles.BusinessDevelopmentHod, roles.marketingExecutive,roles.RDManagerBD,roles.BusinessDevelopmentExecutive]
  },
  
];

export const vendorRoutes = [
  {
    label: 'Home',
    to: routes.vendor,
  }
];

const GENERAL_ACCESS_ROLES = [
  roles.admin,
  roles.purchaseExecutiveGCview,
  roles.managingDirector,
  roles.managerfinance,
  roles.Auditor,
  roles.executiveLeadership,
  roles.viewOnly,
  roles.readOnly,
  roles.Chairman,
  roles.GmProjects,
  roles.ceo,
  roles.factorymanager,
  roles.generalUser,
  roles.gmc,
  roles.marketingExecutive,
  roles.managerCommerical,
  roles.commercialHod,
  roles.commercialExecutive,
  roles.commercialAssociative,
  roles.asstManagerPurchase,
  roles.managerPurchaseGC,
  roles.GeneralManagerPurchase,
  roles.managerGCStores,
  roles.managerStoresPackingAndGC,
  roles.purchaseExecutiveGC,
  roles.gcStoresExecutive,
  roles.srManager,
  roles.qcManager,
  roles.qcHead,
  roles.accountsExecutive,
  roles.accountsManager,
  roles.vendor,
  roles.marketingRepresentative,
  roles.managerPackagingDevelopment,
  roles.purchaseManager,
  roles.managerPurchaseGCQuotes,
  roles.managerPurchasePackaging,
  roles.BDDomestic,
  roles.BusinessDevelopmentManager,
  roles.packingExecutive,
  roles.purchaseExecutiveME,
  roles.rdManager,
  roles.RDManagerBD,
  roles.rdAssociate,
  roles.AnalystQA,
  roles.productionAssistant,
  roles.ProductionManager,
  roles.BDManager,
  roles.BusinessDevelopmentHod,
  roles.BusinessDevelopmentExecutive,
  roles.GMPacking,
  roles.factoryPackingManager,
  roles.productionplanning,
];

export const HomeRoutes = [
  {
    label: 'Home',
    to: routes.home,
    roles: GENERAL_ACCESS_ROLES,
  },
];

// Roles with no matching branch in Home.js's role->report mapping, so they get zero Power BI reports.
const NO_POWERBI_REPORT_ROLES = [
  roles.generalUser,
  roles.gmc,
  roles.marketingExecutive,
  roles.asstManagerPurchase,
  roles.managerStoresPackingAndGC,
  roles.srManager,
  roles.accountsExecutive,
  roles.vendor,
  roles.marketingRepresentative,
  roles.purchaseManager,
  roles.managerPurchaseGCQuotes,
  roles.purchaseExecutiveME,
];

export const DashboardRoutes = [
  {
    label: 'Dashboard',
    to: routes.dashboard,
    roles: GENERAL_ACCESS_ROLES?.filter((r) => !NO_POWERBI_REPORT_ROLES.includes(r)),
  },
];

export const CRMRoutes = [
  {
    label: 'Leads',
    to: routes.leads,
    roles: [ roles.admin,roles.marketingExecutive, roles.RDManagerBD, roles.managingDirector,roles.Auditor,roles.managerfinance, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman, roles.GmProjects, roles.ceo,roles.factorymanager,roles.BDDomestic, roles.BusinessDevelopmentManager,roles.BDManager, roles.BusinessDevelopmentHod, roles.BusinessDevelopmentExecutive],
  },
  {
    label: 'Accounts',
    to: routes.accounts,
    roles: [
      roles.admin,
      roles.rdManager,
      roles.rdAssociate,
      roles.RDManagerBD,
      roles.marketingExecutive,
      roles.managingDirector,
      roles.managerfinance,
      roles.Auditor,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman,
      roles.GmProjects,
      roles.ceo,
      roles.factorymanager,
      roles.BDDomestic,
      roles.BusinessDevelopmentManager,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentExecutive
    ]
  },
  {
    label: 'Contacts',
    to: routes.contacts,
    roles: [ roles.admin, roles.managingDirector,roles.Auditor, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman, roles.GmProjects, roles.ceo,roles.factorymanager,roles.BDDomestic, roles.BusinessDevelopmentManager,roles.BDManager, roles.BusinessDevelopmentHod, roles.BusinessDevelopmentExecutive]
  },
  {
    label: 'Sample Request',
    to: routes.sampleRequest,
    roles: [roles.admin,roles.qcManager, roles.qcHead, roles.rdManager,
      roles.rdAssociate,
      roles.RDManagerBD,roles.marketingExecutive,roles.managerfinance, roles.managingDirector,roles.Auditor, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman, roles.GmProjects, roles.ceo,roles.factorymanager,roles.BDDomestic, roles.BusinessDevelopmentManager,roles.BDManager, roles.BusinessDevelopmentHod, roles.productionAssistant,roles.ProductionManager,roles.BusinessDevelopmentExecutive]
  },
  {
    label: 'Master Samples',
    to: routes.masterSample,
    roles: [
    roles.admin,
    roles.managingDirector,
    roles.rdManager,
    roles.rdAssociate,
    roles.RDManagerBD,
    roles.executiveLeadership,
    roles.viewOnly,
    roles.readOnly,
    roles.Chairman,
    roles.GmProjects]
  },
  {
    label: 'Alternative Samples',
    to: routes.alternativeSample,
    roles:[roles.rdAssociate,roles.managerPurchaseGC,roles.purchaseExecutiveGC,roles.managerfinance,roles.productionplanning, roles.admin,roles.managingDirector, roles.rdManager, roles.RDManagerBD, roles.qcManager, roles.qcHead, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman, roles.GmProjects, roles.ceo,roles.factorymanager,roles.productionAssistant,roles.ProductionManager,roles.BDManager, roles.BusinessDevelopmentHod, roles.BusinessDevelopmentExecutive,roles.BDDomestic,roles.BusinessDevelopmentManager]
  },
  {
    label: 'Customer Samples',
    to: routes.customerSample,
    roles:[ roles.admin,roles.managerPurchaseGC,roles.Auditor,roles.purchaseExecutiveGC,roles.managerfinance,roles.productionplanning,roles.managingDirector, roles.rdManager,
      roles.rdAssociate,
      roles.RDManagerBD, roles.qcManager, roles.qcHead, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman, roles.GmProjects, roles.ceo,roles.factorymanager, roles.BDDomestic, roles.BusinessDevelopmentManager,roles.productionAssistant,roles.ProductionManager,roles.BDManager, roles.BusinessDevelopmentHod, roles.BusinessDevelopmentExecutive]
  },
  {
    label: 'Sample Information',
    to: routes.sampleInformation,
    roles:[ roles.admin,roles.productionplanning,roles.Auditor,roles.managingDirector, roles.managerfinance,roles.BusinessDevelopmentManager,roles.BDDomestic, roles.BDManager, roles.BusinessDevelopmentHod, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman, roles.GmProjects, roles.ceo,roles.BusinessDevelopmentExecutive]
  },
  {
    label: 'Quotation',
    to: routes.quotation,
    roles: [
      roles.admin,
      roles.gmc,
      roles.BusinessDevelopmentExecutive,
      roles.managerCommerical,
      roles.commercialExecutive,
      roles.commercialHod,
      roles.purchaseExecutiveGC,
      roles.managingDirector,
      roles.Auditor,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman,
      roles.managerfinance,
      roles.GmProjects,
      roles.ceo,
      roles.factorymanager,
      roles.asstManagerPurchase,
      roles.marketingExecutive,
      roles.RDManagerBD,
      roles.managerPurchaseGC,
      roles.GeneralManagerPurchase,
      roles.packingExecutive,
      roles.BDDomestic,
      roles.BusinessDevelopmentManager,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.managerPurchasePackaging,
      roles.GMPacking
    ]
  },
  {
    label: 'QLI',
    to: routes.qlireports,
    roles: [
      roles.admin,
      roles.managingDirector,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,
      roles.Chairman,
      roles.GmProjects,
      roles.ceo,
      roles.managerCommerical,
      roles.commercialExecutive,
      roles.commercialHod,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentExecutive,
      roles.BDDomestic,
      roles.BusinessDevelopmentManager,
      roles.productionplanning
    ]
  },
  {
    label: 'FG Validity',
    to: routes.FGvalidity,
    roles: [
    roles.admin,
    roles.managingDirector,
    roles.BDDomestic,
    roles.rdManager,
    roles.rdAssociate,
    roles.RDManagerBD,
    roles.managerfinance,
    roles.Auditor,
    roles.executiveLeadership,
    roles.viewOnly,
    roles.readOnly,
    ]
  },
];

export const CommercialRoutes = [
  {
    label: 'Order',
    to: routes.order,
    roles: [
      roles.admin,
      roles.gmc,
      roles.productionplanning,
      roles.managerCommerical,
      roles.commercialHod,
      roles.commercialExecutive,
      roles.commercialAssociative,
      roles.managingDirector,
      roles.Auditor,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman,
      roles.managerfinance,
      roles.GmProjects,
      roles.ceo,
      roles.factorymanager,
      roles.asstManagerPurchase,
      roles.GeneralManagerPurchase,
      roles.packingExecutive,
      roles.BusinessDevelopmentManager,
      roles.BDDomestic,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentExecutive
    ]
  },
  {
    label: 'Order Line Item',
    to: routes.orderLineItem,
    roles: [
      roles.admin,
      roles.gmc,
      roles.productionplanning,
      roles.managerCommerical,
      roles.commercialHod,
      roles.commercialExecutive,
      roles.commercialAssociative,
      roles.managingDirector,
      roles.Auditor,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman,
      roles.managerfinance,
      roles.GmProjects,
      roles.ceo,
      roles.factorymanager,
      roles.asstManagerPurchase,
      roles.GeneralManagerPurchase,
      roles.packingExecutive,
      roles.BusinessDevelopmentManager,
      roles.BDDomestic,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentExecutive
    ]
  },
  {
    label: 'Order Dispatch',
    to: routes.orderDispatch,
    roles: [
      roles.admin,
      roles.gmc,
      roles.productionplanning,
      roles.productionAssistant,
      roles.ProductionManager,
      roles.managerCommerical,
      roles.commercialHod,
      roles.commercialExecutive,
      roles.commercialAssociative,
      roles.GMPacking,
      roles.managingDirector,
      roles.Auditor,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman,
      roles.managerfinance,
      roles.GmProjects,
      roles.ceo,
      roles.factorymanager,
      roles.asstManagerPurchase,
      roles.GeneralManagerPurchase,
      roles.packingExecutive,
      roles.BusinessDevelopmentManager,
      roles.BDDomestic,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentExecutive,
      roles.qcManager,
      roles.qcHead,
      roles.managerGCStores,
      roles.gcStoresExecutive,
      roles.managerPurchasePackaging
    ]
  },
  {
    label:'Soft Schedule',
    to: routes.softscheduling,
    roles: [
      roles.admin,
      roles.managingDirector,
      roles.managerCommerical,
      roles.commercialExecutive,
      roles.commercialHod,
      roles.productionplanning,
      roles.BusinessDevelopmentManager,
      roles.BDDomestic,
      roles.managerfinance,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman,
      roles.GmProjects,
      roles.ceo,
      roles.factorymanager,
      roles.BusinessDevelopmentExecutive,
      roles.Auditor,
      roles.managerPurchaseGC,
      roles.purchaseExecutiveGC,
      roles.commercialAssociative
    ]
  },
];


export const PurchseRoutes = [
  {
    label: 'Purchase Orders',
    to: routes.purchaseOrders,
    roles: [ roles.admin,roles.managingDirector, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman, roles.GmProjects, roles.Auditor,roles.ceo,roles.factorymanager, roles.managerPurchaseGC, roles.GeneralManagerPurchase,
    roles.managerStoresPackingAndGC, roles.purchaseExecutiveGC,
    roles.asstManagerPurchase, roles.gcStoresExecutive,
    roles.accountsManager, roles.managerGCStores,roles.purchaseExecutiveGCview, roles.qcManager, roles.qcHead]
  }, 
  {
    label: 'Debit Note GC',
    to: routes.debitNoteGC,
    roles: [ roles.admin,roles.managingDirector,roles.Auditor, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman, roles.GmProjects, roles.ceo,roles.factorymanager, roles.managerPurchaseGC,roles.GeneralManagerPurchase,
    roles.accountsExecutive, roles.accountsManager,roles.purchaseExecutiveGC]
  },
  {
    label: 'MRIN',
    to: routes.mrin,
    roles: [ roles.admin,roles.gcStoresExecutive,roles.purchaseExecutiveGCview, roles.managerStoresPackingAndGC,
    roles.srManager, roles.qcManager, roles.qcHead, roles.managingDirector,roles.Auditor, roles.executiveLeadership,
    roles.viewOnly,
    roles.readOnly,
    roles.managerfinance,roles.Chairman, roles.GmProjects, roles.ceo,roles.factorymanager, roles.accountsExecutive,
    roles.accountsManager, roles.managerPurchaseGC,roles.GeneralManagerPurchase, roles.managerGCStores, roles.AnalystQA,roles.purchaseExecutiveGC,roles.rdManager,
    roles.rdAssociate,
    roles.RDManagerBD]
  },
  {
    label: 'GC',
    to: routes.gc,
    roles: [ roles.admin,roles.managingDirector,roles.Auditor, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman,roles.GmProjects, roles.ceo,roles.factorymanager, roles.gcStoresExecutive,
    roles.managerStoresPackingAndGC, roles.managerPurchaseGC,roles.GeneralManagerPurchase, roles.managerGCStores,roles.purchaseExecutiveGC, roles.rdManager,
    roles.rdAssociate,
    roles.RDManagerBD],
  },
  {
    label: 'Supplier',
    to: routes.supplier,
    roles: [ roles.admin,roles.managingDirector,roles.purchaseExecutiveGC,roles.Auditor, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman, roles.GmProjects, roles.ceo,roles.factorymanager, roles.purchaseManager, roles.managerPurchaseGC,roles.GeneralManagerPurchase, roles.accountsManager, roles.purchaseExecutiveME]
  },
  // {
  //   label: 'Tax Settings',
  //   to: routes.settings,
  //   roles: [roles.admin]
  // },
  {
    label: 'Packing Type',
    to: routes.packingType,
    roles: [ roles.admin,roles.managingDirector, roles.packingExecutive, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman, roles.GmProjects, roles.ceo,roles.factorymanager,roles.managerPurchasePackaging, roles.Auditor, roles.BusinessDevelopmentHod,roles.GMPacking]
  },
  {
    label: 'Dispatch Info',
    to: routes.dispatchinfo,
    roles: [ roles.admin, roles.managingDirector, roles.vendor, roles.managerPurchaseGC, roles.purchaseExecutiveGC,roles.Auditor,roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance, roles.Chairman, roles.GmProjects, roles.ceo,roles.factorymanager, roles.qcManager, roles.qcHead ]
  },
  {
    label: 'Allocations',
    to: routes.allocation,
    roles: [ roles.admin, roles.managingDirector,roles.Auditor, roles.BusinessDevelopmentManager,roles.managerfinance,roles.BDDomestic,roles.BDManager, roles.BusinessDevelopmentHod, roles.managerPurchaseGC ,roles.purchaseExecutiveGC,roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman, roles.GmProjects, roles.ceo,roles.BusinessDevelopmentExecutive, roles.qcManager, roles.qcHead, roles.rdManager,
      roles.rdAssociate,
      roles.RDManagerBD]
  },
  {
    label: 'GC Required',
    to: routes.gcrequired,
    roles: [ roles.admin, roles.managingDirector, roles.Auditor, roles.managerPurchaseGC ,roles.purchaseExecutiveGC,roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman, roles.GmProjects, roles.ceo]
  },
  {
    label: 'GC Daily Rates',
    to: routes.gcdailyrates,
    roles: [ roles.admin, roles.managingDirector,roles.managerPurchaseGC,roles.Auditor,roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman, roles.GmProjects, roles.purchaseExecutiveGC]
  },
  {
    label: 'GC Enquiry',
    to: routes.gcenquiry,
    roles: [ roles.admin, roles.managingDirector,roles.managerPurchaseGC,roles.purchaseExecutiveGC,roles.Auditor,roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman, roles.GmProjects, ]
  },
  {
    label: 'Type / Pre-Shipment Sample',
    to: routes.preShipmentSample,
    roles: [
      roles.admin,
      roles.managingDirector,
      roles.rdManager,
      roles.rdAssociate,
      roles.RDManagerBD,
      roles.qcManager,
      roles.qcHead,
      roles.ceo,
      roles.purchaseExecutiveGC,
      roles.managerPurchaseGC,
      roles.Auditor,
      roles.factorymanager,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly
    ]
  },
];

export const AdminRoutes = [
  {
    label: 'Users',
    to: routes.users,
    roles: [roles.admin, roles.managingDirector, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman, roles.GmProjects, roles.Auditor,roles.ceo]
  },
];

export const ProductionRoutes = [
  {
    label:'Production Schedule',
    to: routes.productionSchedule,
    roles: [ roles.admin,
      roles.managingDirector,
      roles.managerCommerical,
      roles.commercialExecutive,
      roles.commercialHod,
      roles.productionplanning,
      roles.productionAssistant,
      roles.ProductionManager,
      roles.factorymanager,
      roles.ceo,
      roles.Chairman,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.qcManager,
      roles.qcHead,
      roles.GmProjects,
      roles.managerPurchaseGC,
      roles.purchaseExecutiveGC,
      roles.purchaseExecutiveGCview,
      roles.BDDomestic,
      roles.rdManager,
      roles.rdAssociate,
      roles.RDManagerBD,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentManager,
      roles.BusinessDevelopmentExecutive,
      roles.Auditor,
      roles.managerGCStores,
      roles.gcStoresExecutive,
      roles.GMPacking,
      roles.commercialAssociative,
      roles.managerPurchasePackaging
     ]
  },
  {
    label: 'Blend Sheets',
    to: routes.blendSheet,
    roles: [roles.admin,
    roles.productionplanning,
    roles.Auditor,
    roles.managingDirector,
    roles.executiveLeadership,
    roles.viewOnly,
    roles.readOnly,
    roles.managerfinance,
    roles.Chairman,
    roles.GmProjects,
    roles.ceo,
    roles.factorymanager,
    roles.qcManager,
    roles.qcHead,
    roles.AnalystQA,
    roles.productionAssistant,
    roles.ProductionManager,
    roles.gcStoresExecutive,
    roles.managerGCStores,
    roles.rdManager,
    roles.rdAssociate,
    roles.RDManagerBD,
    roles.managerCommerical,
    roles.commercialAssociative,
    roles.commercialExecutive]
  },
  {
    label: 'Batch Output',
    to: routes.batchoutput,
    roles: [roles.rdAssociate,roles.Auditor,roles.productionplanning, roles.admin,roles.managingDirector, roles.rdManager,
      roles.rdAssociate,
      roles.RDManagerBD, roles.qcManager, roles.qcHead, roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman, roles.GmProjects, roles.ceo,roles.factorymanager,roles.ProductionManager,roles.productionAssistant,
      roles.managerPurchaseGC,
      roles.purchaseExecutiveGC,
      roles.purchaseExecutiveGCview,
    ]
  },
  {
    label: 'Certification',
    to: routes.certification,
    roles:  [ roles.admin,
      roles.managingDirector,
      roles.Auditor,
      roles.productionplanning,
      roles.managerfinance,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.Chairman,
      roles.GmProjects,
      roles.ceo,
      roles.factorymanager,
      roles.qcManager, 
      roles.qcHead, 
      roles.AnalystQA,
      roles.BusinessDevelopmentManager,
      roles.BDDomestic,
      roles.BDManager, 
      roles.BusinessDevelopmentHod, 
      roles.marketingExecutive, 
      roles.RDManagerBD,
      roles.BusinessDevelopmentExecutive
    ]
  },
]

export const AuditreportsRoutes = [
  {
    label: 'Audit Reports',
    to: routes.auditreports,
    roles: [roles.admin,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,roles.Chairman, roles.GmProjects, roles.managingDirector,roles.ceo,roles.Auditor]
  },
  
]

// Finance module routes
export const FinanceRoutes = [
  {
    label: 'Finance Costing',
    to: routes.finance,
    roles: [
      roles.admin,
      roles.managingDirector,
      roles.executiveLeadership,
      roles.viewOnly,
      roles.readOnly,
      roles.managerfinance,
      roles.GmProjects,
      roles.BusinessDevelopmentManager,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentExecutive,
      roles.BDDomestic,
      roles.factoryPackingManager,
      roles.Auditor,
      roles.factorymanager,
    ]
  },
]